module.exports = __webpack_public_path__ + "img/FR15668.a80d518b.png";